"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodeEnum = void 0;
var ErrorCodeEnum;
(function (ErrorCodeEnum) {
    ErrorCodeEnum["BANKING_SERVICE_ERROR"] = "BANKING_SERVICE_ERROR";
    ErrorCodeEnum["BASIC_APPROVAL_RIGHT_REVOKED"] = "BASIC_APPROVAL_RIGHT_REVOKED";
    ErrorCodeEnum["CRON_JOB_LOCKED"] = "CRON_JOB_LOCKED";
    ErrorCodeEnum["INVALID_EXPENSE_AMOUNTS"] = "INVALID_EXPENSE_AMOUNTS";
    ErrorCodeEnum["INVALID_SYSTEM_TIME"] = "INVALID_SYSTEM_TIME";
    ErrorCodeEnum["MAINTENANCE"] = "MAINTENANCE";
    ErrorCodeEnum["ACCESS_DISABLED"] = "ACCESS_DISABLED";
    ErrorCodeEnum["MISSING_IP_ADDRESS"] = "MISSING_IP_ADDRESS";
    ErrorCodeEnum["MOBILE_ALREADY_ENROLLED"] = "MOBILE_ALREADY_ENROLLED";
    ErrorCodeEnum["MOBILE_ENROLLEMENT_RESET"] = "MOBILE_ENROLLEMENT_RESET";
    ErrorCodeEnum["NO_EMAIL_ALIAS"] = "NO_EMAIL_ALIAS";
    ErrorCodeEnum["OCR_CONTENT_TYPE_INVALID"] = "OCR_CONTENT_TYPE_INVALID";
    ErrorCodeEnum["OCR_CONTENT_TYPE_UNDETECTABLE"] = "OCR_CONTENT_TYPE_UNDETECTABLE";
    ErrorCodeEnum["OCR_EINVOICE_DOES_NOT_PASS_VALIDATION"] = "OCR_EINVOICE_DOES_NOT_PASS_VALIDATION";
    ErrorCodeEnum["OCR_INVALID_DOCUMENT_DATA"] = "OCR_INVALID_DOCUMENT_DATA";
    ErrorCodeEnum["OCR_INVALID_EINVOICE"] = "OCR_INVALID_EINVOICE";
    ErrorCodeEnum["OCR_INVALID_EINVOICE_TYPE"] = "OCR_INVALID_EINVOICE_TYPE";
    ErrorCodeEnum["OCR_NO_DATA_IN_DOCUMENT"] = "OCR_NO_DATA_IN_DOCUMENT";
    ErrorCodeEnum["OCR_NO_DOCUMENT_PROVIDED"] = "OCR_NO_DOCUMENT_PROVIDED";
    ErrorCodeEnum["OCR_ONLY_ONE_DOCUMENT_ALLOWED"] = "OCR_ONLY_ONE_DOCUMENT_ALLOWED";
    ErrorCodeEnum["OCR_PAGE_RANGE_INVALID"] = "OCR_PAGE_RANGE_INVALID";
    ErrorCodeEnum["OCR_PREFERRED_PROVIDER_NOT_FOUND"] = "OCR_PREFERRED_PROVIDER_NOT_FOUND";
    ErrorCodeEnum["OCR_READ_ERROR"] = "OCR_READ_ERROR";
    ErrorCodeEnum["OCR_READ_ERROR_DOCUMENT_COULD_NOT_BE_LOADED"] = "OCR_READ_ERROR_DOCUMENT_COULD_NOT_BE_LOADED";
    ErrorCodeEnum["OCR_READ_ERROR_EMPTY_DOCUMENT"] = "OCR_READ_ERROR_EMPTY_DOCUMENT";
    ErrorCodeEnum["OCR_READ_ERROR_INVALID_BASE_64"] = "OCR_READ_ERROR_INVALID_BASE_64";
    ErrorCodeEnum["OCR_READ_ERROR_INVALID_FILE_ID"] = "OCR_READ_ERROR_INVALID_FILE_ID";
    ErrorCodeEnum["OCR_READ_ERROR_INVALID_URL"] = "OCR_READ_ERROR_INVALID_URL";
    ErrorCodeEnum["OCR_READ_ERROR_TIMEOUT"] = "OCR_READ_ERROR_TIMEOUT";
    ErrorCodeEnum["OCR_READ_ERROR_UNEXPECTED_RESPONSE"] = "OCR_READ_ERROR_UNEXPECTED_RESPONSE";
    ErrorCodeEnum["OCR_UNIVERSAL_INVOICE_DOES_NOT_PASS_VALIDATION"] = "OCR_UNIVERSAL_INVOICE_DOES_NOT_PASS_VALIDATION";
    ErrorCodeEnum["OCR_UNSUPPORTED_EINVOICE_FORMAT"] = "OCR_UNSUPPORTED_EINVOICE_FORMAT";
    ErrorCodeEnum["PARALLEL_EDITING"] = "PARALLEL_EDITING";
    ErrorCodeEnum["REQUESTING_SESSION_NOT_AUTHENTICATED"] = "REQUESTING_SESSION_NOT_AUTHENTICATED";
    ErrorCodeEnum["REQUESTING_SESSION_NOT_FOUND"] = "REQUESTING_SESSION_NOT_FOUND";
    ErrorCodeEnum["WEAVR_AUTH_REQUIRED"] = "WEAVR_AUTH_REQUIRED";
    ErrorCodeEnum["WEAVR_CHALLENGE_LIMIT_EXCEEDED"] = "WEAVR_CHALLENGE_LIMIT_EXCEEDED";
    ErrorCodeEnum["WEAVR_ONE_CHALLENGE_LIMIT_REMAINING"] = "WEAVR_ONE_CHALLENGE_LIMIT_REMAINING";
    ErrorCodeEnum["WEAVR_STEP_UP_AUTH_REQUIRED"] = "WEAVR_STEP_UP_AUTH_REQUIRED";
})(ErrorCodeEnum || (exports.ErrorCodeEnum = ErrorCodeEnum = {}));
